import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

function Breedcumb({ list }) {
  function handleClickBreadcrumbs(event) {
    event.preventDefault();
  }

  return (
    <div className="breedcumb-section">
      <div className="container">
        <div role="presentation" onClick={handleClickBreadcrumbs}>
          <Breadcrumbs
            sx={{
              "& .MuiBreadcrumbs-li": {
                listStyle: "none",
                mb: "20px !important",
              },
            }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link underline="hover" color="inherit" to="/">
              Home
            </Link>
            {list ? (
              list.map((e, index) => {
                if (index === list.length - 1) {
                  // Render the last item as Typography (non-clickable)
                  return (
                    <Typography
                      key={index}
                      color="text.primary"
                      className="active"
                    >
                      {e?.text}
                    </Typography>
                  );
                }
                return (
                  <Link
                    key={index}
                    underline="hover"
                    color="inherit"
                    to={e?.link}
                  >
                    {e?.text}
                  </Link>
                );
              })
            ) : (
              <Typography underline="hover" color="text.primary">
                Health Packages
              </Typography>
            )}
          </Breadcrumbs>
        </div>
      </div>
    </div>
  );
}

export default Breedcumb;
